module.exports = __webpack_public_path__ + "static/media/ram.69d88e1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ram.svg
// module id = 154
// module chunks = 0